module.exports = __webpack_public_path__ + "img/hat.d3c19b.svg";